<div *ngIf="!isEdited" class="cell-view">
  <div class="inner-view">
    {{ getRepresentation() }}
  </div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="FloatCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="FloatCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="p-inputgroup">
    <p-inputNumber
      #floatInput
      [name]="fieldName"
      mode="decimal"
      [minFractionDigits]="0"
      [maxFractionDigits]="decimals === null ? 20 : decimals"
      [(ngModel)]="rowData[fieldName]"
      (click)="$event.stopPropagation()"
      (keyup.enter)="onKeyupEnter(floatInput)"
      (keyup.esc)="abortCellEdit($event)"
      (onBlur)="abortCellEdit($event)"
      jmlAutoFocus
    ></p-inputNumber>
    <button pButton type="button" [id]="fieldName + '§' + rowData['id']" icon="pi pi-check"></button>
  </div>
</ng-template>
